import { render, staticRenderFns } from "./QuickServe.vue?vue&type=template&id=9ca4bce8&scoped=true"
import script from "./QuickServe.vue?vue&type=script&lang=js"
export * from "./QuickServe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca4bce8",
  null
  
)

export default component.exports